import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { MEDIA_EVENTS } from '../../../../common/hooks/use-media-performance/constants';
import { useTrackInteractionLatency } from '../../../../common/hooks/use-track-interaction-latency';
import { selectedVideoIndexAtom } from '../../../labelling-v2/atoms/multi-video-atoms';
import { PERFORMANCE_METRIC_EVENTS } from '../../../labelling-v2/constants/performance';
import { usePerformanceMetrics } from '../../../labelling-v2/hooks/performance/use-performance-metrics';
import { useMediaStateMediaElement, useMediaStateOnSeekToFrame } from '../../providers/hooks/use-media-state';
import { useMediaStateLiteMediaElement, useMediaStateLiteOnSeekToFrame } from '../../providers/hooks/use-media-state-lite';
import useAnalyticsForVideoLabelling from './analytics/useAnalyticsForVideoLabelling';
export function useHandleFrameChange() {
  const isMultiVideoIndex = useAtomValue(selectedVideoIndexAtom) !== 0;
  const onSeekToFrame = useMediaStateOnSeekToFrame();
  const onSeekToFrameLite = useMediaStateLiteOnSeekToFrame();
  const onSeek = isMultiVideoIndex ? onSeekToFrameLite : onSeekToFrame;
  const primaryMediaElement = useMediaStateMediaElement();
  const secondaryMediaElement = useMediaStateLiteMediaElement();
  const mediaElement = isMultiVideoIndex ? secondaryMediaElement : primaryMediaElement;
  const {
    sendEventVideoFrameSelect
  } = useAnalyticsForVideoLabelling();
  const {
    captureLatency
  } = usePerformanceMetrics();
  const handleFrameChange = useCallback((index: number) => {
    onSeek(index);
    sendEventVideoFrameSelect({
      selectedFrame: index
    });
  }, [onSeek, sendEventVideoFrameSelect]);
  return useTrackInteractionLatency(handleFrameChange, mediaElement, {
    metricName: PERFORMANCE_METRIC_EVENTS.VIDEO_SEEK_TO_PAINT,
    event: MEDIA_EVENTS.SEEKED,
    captureLatency
  });
}